import paths from "../lib/paths";


const Loader = () => {
  return (
    <div className="preloader_cont">
      <div className="precontainer_cont">
        <div className="preloader-logo">
          <img
            src={`${paths.svgs}/LOGO.svg`}
            alt="logo"
          />
        </div>
        <div className="ring"></div>
      </div>
    </div>
  );
};

export default Loader;
